import React, { useEffect, useRef } from 'react';
import usePolishedAudioSting from './usePolishedAudioSting';

export const LOCALOPS_ACTION_CREDIT_THEME_URL =
  process.env.REACT_APP_LOCALOPS_ACTION_CREDIT_AUDIO_URL ||
  'https://res.cloudinary.com/joegalaxy/video/upload/v1782691946/12._JOE_GALAXY_-_Grindin_By_Myself_-_MASTERED_DK_320Kbps_pg1vur.mp3';
export const LOCALOPS_ACTION_CREDIT_THEME_CLIP_START_SECONDS = 16.2;
export const LOCALOPS_ACTION_CREDIT_THEME_CLIP_END_SECONDS = 24.2;

const envFlagEnabled = () =>
  String(process.env.REACT_APP_LOCALOPS_ACTION_CREDIT_AUDIO_ENABLED || 'true')
    .trim()
    .toLowerCase() !== 'false';

export default function LocalOpsActionCreditAudioMoment({
  enabled,
  autoPlay = true,
  audioUrl = LOCALOPS_ACTION_CREDIT_THEME_URL,
  actionCreditAwarded = false,
  actionCreditEligibleForViewer = false,
}) {
  const resolvedEnabled = typeof enabled === 'boolean' ? enabled : envFlagEnabled();
  const shouldRender =
    resolvedEnabled &&
    !!audioUrl &&
    actionCreditAwarded === true &&
    actionCreditEligibleForViewer === true;

  const autoPlayAttemptedRef = useRef(false);
  const { play, blocked, playing, playedOnce } = usePolishedAudioSting({
    url: audioUrl,
    enabled: shouldRender,
    clipStartSeconds: LOCALOPS_ACTION_CREDIT_THEME_CLIP_START_SECONDS,
    clipEndSeconds: LOCALOPS_ACTION_CREDIT_THEME_CLIP_END_SECONDS,
    targetVolume: 0.42,
    fadeInMs: 320,
    fadeOutMs: 800,
  });

  useEffect(() => {
    if (!shouldRender) {
      autoPlayAttemptedRef.current = false;
      return;
    }
    if (!autoPlay) return;
    if (autoPlayAttemptedRef.current) return;
    autoPlayAttemptedRef.current = true;
    play();
  }, [autoPlay, play, shouldRender]);

  if (!shouldRender) return null;

  const buttonLabel = playing
    ? 'Playing theme'
    : playedOnce
    ? 'Replay theme'
    : 'Play theme';

  return (
    <div
      data-testid="localops-action-credit-audio-moment"
      style={{
        marginTop: 12,
        padding: '10px 12px',
        borderRadius: 12,
        border: '1px solid rgba(250,204,21,0.24)',
        background: 'rgba(15,23,42,0.38)',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: 10,
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{
            minWidth: 180,
            flex: '1 1 220px',
            color: '#dbeafe',
            fontSize: 12,
            lineHeight: 1.35,
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          <span style={{ color: '#fde68a', fontWeight: 900 }}>
            JG LocalOps theme:
          </span>{' '}
          &quot;Grindin&apos; by Myself&quot; by Joe Galaxy
        </div>
        <button
          type="button"
          onClick={play}
          disabled={playing}
          aria-label={buttonLabel}
          title="Theme song clip"
          style={{
            flex: '0 0 auto',
            minHeight: 34,
            padding: '8px 12px',
            borderRadius: 999,
            border: '1px solid rgba(250,204,21,0.34)',
            background: playing
              ? 'rgba(226,232,240,0.14)'
              : 'linear-gradient(90deg, #facc15, #22d3ee)',
            color: playing ? '#cbd5e1' : '#0f172a',
            fontSize: 12,
            fontWeight: 900,
            cursor: playing ? 'default' : 'pointer',
            opacity: playing ? 0.72 : 1,
          }}
        >
          {buttonLabel}
        </button>
      </div>
      {blocked ? (
        <div
          style={{
            marginTop: 6,
            color: '#bfdbfe',
            fontSize: 12,
            lineHeight: 1.35,
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          Tap Play theme to hear the clip.
        </div>
      ) : null}
    </div>
  );
}
